import "./pages.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";

import ProjectSection from "./Components/projects/projectSection";
import Title from "./Components/intro/title";
import Footer from "./Components/Footer/footer";

const Page1 = () => {
  return (
    <section id="home" className="page-1">
      <Title />
    </section>
  );
};

function Main() {
  return (
    <div>
      <div className="main-container">
        <Page1 />
        <ProjectSection />
      </div>
      <Footer />
    </div>
  );
}

export default Main;
